import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


const MissionVision = () => {
   useEffect(() => {
        AOS.init({ duration: 1000 });
      }, []);

  return (
    <div className="w-[90%] mx-auto flex flex-col lg:flex-row justify-between items-start lg:items-center gap-10 p-10">
      {/* Left Content */}
      <div className="lg:w-1/2 w-full" data-aos="fade-down-left">
        <h2 className="text-4xl font-bold text-gray-900 mb-6">Mission & Vision</h2>
        <h3 className="text-3xl font-semibold text-gray-800 mb-4">
          Our Commitment to Excellence in Construction
        </h3>
        <p className="text-gray-700 mb-4">
          At <span className="font-bold">PACIFIC BUILDERS (PVT) LTD</span>, we aim to be a dynamic team delivering the highest 
          <span className="text-blue-500 font-semibold"> quality construction services</span>, helping to shape a prosperous and modern <span className="font-semibold">Pakistan</span>.
        </p>
        <p className="text-gray-700 mb-4">
          We are committed to becoming the construction company of choice, driven by discipline, innovation, and dedication. Through strategic expertise and a results-focused mindset, we deliver superior outcomes for our clients.
        </p>
        <p className="text-gray-700">
          Our <span className="font-semibold">vision</span> is to be recognized as a leader in the construction industry—trusted for our 
          excellence, modern techniques, sustainable solutions, and customer-centric approach. Every project we undertake reflects our promise of creativity, quality, comfort, and long-term durability.
        </p>
      </div>

      {/* Right Image */}
      <div className="relative lg:w-1/2 w-full" data-aos="flip-right">
        <img
          src="/images/Picture1.jpg"
          alt="Construction Site"
          className="w-full rounded-lg shadow-md"
        />
      </div>
    </div>
  );
};

export default MissionVision;
